import React, { FC } from 'react';
import { Code01, Code02, HelperText01, Label01 } from 'ozone/atoms';
import { SubHeading2 } from './components';
import { TypeToken } from './type-token';

export const SupportingStyles: FC = () => (
  <>
    <SubHeading2>Supporting styles</SubHeading2>
    <TypeToken component={Code01}>
      This is for inline code snippets and smaller code elements.
    </TypeToken>
    <TypeToken component={Code02}>
      This is for large code snippets and larger code elements.
    </TypeToken>
    <TypeToken component={Label01}>
      This is for field labels in components and error messages.
    </TypeToken>
    <TypeToken component={HelperText01}>
      This is for explanatory helper text that appears below a field title
      within a component.
    </TypeToken>
  </>
);
